@let isLoadingResult = isLoading | async;

@if (isLoadingResult) {
  <div class="api-loader--wrapper">
    <nx-spinner size="large"></nx-spinner>
  </div>
}

<div [ngClass]="isLoadingResult ? 'api-loader--page-content' : ''">
  <ng-content></ng-content>
</div>
